export default __webpack_public_path__ + "static/Automated-solutions-09bb89d8752ab8839b6ca9524be721f5.webp";